import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import "./App.css";
import bymoLogo from "./img/bymo.png";

const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(""); // Clear previous error messages
        try {
            const adminDocRef = doc(db, "admin", email); // Fetch admin doc using email
            const adminDoc = await getDoc(adminDocRef);

            if (adminDoc.exists() && adminDoc.data().password === password) {
                // Save login state in session storage
                sessionStorage.setItem("isAdminLoggedIn", "true");
                sessionStorage.setItem("adminEmail", email);

                onLogin(); // Set admin login state
                navigate("/side-user-access");
            } else {
                setError("Invalid admin credentials.");
            }
        } catch (err) {
            console.error("Error during admin login:", err);
            setError("An error occurred while logging in. Please try again.");
        }
    };

    return (
        <div className="container">
            <div className="login-admin-box">
                <img src={bymoLogo} alt="BYMO Logo" className="logo" />
                <form onSubmit={handleLogin}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="input-field"
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="input-field"
                        required
                    />
                    <button type="submit" className="login-user-main-button">Login Admin</button>
                </form>
                {error && <p className="error-message">{error}</p>}
            </div>
        </div>
    );
};

export default AdminLogin;
